module.exports = "<!-- Copyright (C) 2016 NooBaa -->\n\n<checkbox params=\"checked: $data\"></checkbox>\n";
